/**
 * @generated SignedSource<<81fa5bbe182c37e174fa8ff060e8acb1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TaskExecutionHeaderComponent_Task$data = {
  readonly id: string;
  readonly images: ReadonlyArray<{
    readonly id: string;
    readonly sizes: ReadonlyArray<{
      readonly height: number;
      readonly width: number;
    }>;
    readonly " $fragmentSpreads": FragmentRefs<"AHImageStackComponent_Images" | "Image_image">;
  }>;
  readonly instructions: string | null;
  readonly title: string;
  readonly " $fragmentType": "TaskExecutionHeaderComponent_Task";
};
export type TaskExecutionHeaderComponent_Task$key = {
  readonly " $data"?: TaskExecutionHeaderComponent_Task$data;
  readonly " $fragmentSpreads": FragmentRefs<"TaskExecutionHeaderComponent_Task">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TaskExecutionHeaderComponent_Task",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "instructions",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "images",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "ImageSize",
          "kind": "LinkedField",
          "name": "sizes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "height",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "width",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Image_image"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AHImageStackComponent_Images"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Task",
  "abstractKey": "__isTask"
};
})();

(node as any).hash = "e4b5766b9bd1fd9aed82c06d57fb97ec";

export default node;
